import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO1.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import agua from '../../assets/videos/agua.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import $, { when } from "jquery";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import seta from '../../assets/svgs/more-white.svg';      


class EstruturaTO1 extends Component {
   
    componentDidMount(){
   

            // info button transitions
            $(".ffechar").click(function() {
                console.log("aaaaaa");
                $(".sidebar-wrapper").removeClass("show-sidebar", 500);
              $(".ffechar").addClass("todonone", 500);
        
            });

            $(".menuuu").click(function() {
                console.log("aaaaaa");
              $(".sidebar-wrapper").toggleClass("show-sidebar", 500);
              $(".ffechar").removeClass("todonone", 500);
        
            });
            $("#dimensao").click(function()
            {
                $(".sidebar-wrapper").removeClass("show-sidebar", 500);
                $(".menuuu").addClass("todonone");
                $(".ffechar").addClass("todonone", 500);

            
              $("#video").prop('muted', false);
              $("#dimensao").addClass("todonone");
              $("#dimensao2").removeClass("todonone");
              $("#desapa2").addClass("todonone");
              $("#video").addClass("pulo");
    
              $("#TO7dimensao").removeClass("todonone");
              $("#TO7desapa2").removeClass("todonone");
              $("#TO7obra1").removeClass("pulo");
              $("#TO7obra1").removeClass("pulo");
              $("#TO7video").removeClass("pulo");
              $("#TO7local1").removeClass("pulo");
              $("#TO7video").prop('muted', true);
    
              $("#TO6dimensao").removeClass("todonone");
              $("#TO6desapa2").removeClass("todonone");
              $("#TO6obra1").removeClass("pulo");
              $("#TO6obra1").removeClass("pulo");
              $("#TO6video").removeClass("pulo");
              $("#TO6local1").removeClass("pulo");
              $("#TO6video").prop('muted', true);
    
              $("#TO5dimensao").removeClass("todonone");
              $("#TO5desapa2").removeClass("todonone");
              $("#TO5obra1").removeClass("pulo");
              $("#TO5obra1").removeClass("pulo");
              $("#TO5video").removeClass("pulo");
              $("#TO5local1").removeClass("pulo");
              $("#TO5video").prop('muted', true);
    
              $("#TO4dimensao").removeClass("todonone");
              $("#TO4desapa2").removeClass("todonone");
              $("#TO4obra1").removeClass("pulo");
              $("#TO4obra1").removeClass("pulo");
              $("#TO4video").removeClass("pulo");
              $("#TO4local1").removeClass("pulo");
              $("#TO4video").prop('muted', true);
    
              $("#TO3dimensao").removeClass("todonone");
              $("#TO3desapa2").removeClass("todonone");
              $("#TO3obra1").removeClass("pulo");
              $("#TO3obra1").removeClass("pulo");
              $("#TO3video").removeClass("pulo");
              $("#TO3local1").removeClass("pulo");
              $("#TO3video").prop('muted', true);
    
              $("#TO8dimensao").removeClass("todonone");
              $("#TO8desapa2").removeClass("todonone");
              $("#TO8obra1").removeClass("pulo");
              $("#TO8obra1").removeClass("pulo");
              $("#TO8video").removeClass("pulo");
              $("#TO8local1").removeClass("pulo");
              $("#TO8video").prop('muted', true);
    
              $("#TO2dimensao").removeClass("todonone");
              $("#TO2desapa2").removeClass("todonone");
              $("#TO2obra1").removeClass("pulo");
              $("#TO2obra1").removeClass("pulo");
              $("#TO2video").removeClass("pulo");
              $("#TO2local1").removeClass("pulo");
              $("#TO2video").prop('muted', true);
    
          
        
            }
            );
            $("#dimensao2").click(function()
            
            {

                $(".menuuu").removeClass("todonone");
                

              $("#TO2video").prop('muted', true);
              $("#TO2dimensao2").addClass("todonone");
              $("#TO2dimensao").removeClass("todonone");
              $("#TO2desapa2").removeClass("todonone");
              $("#TO2obra1").removeClass("pulo");
              $("#TO2obra1").removeClass("pulo");
              $("#TO2video").removeClass("pulo");
              $("#TO2local1").removeClass("pulo");

              
            }
            );

    }

    render() {
        return (
            <div id="obra1" className="displayTO1 gatilhoObra"> {this.props.children}
                <div id="local1"className="videolocalTO1" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                    <div className="sidebar-wrapper">
                        <div className="sidebar">
                            <h3> 2013 - 2014   </h3>
                            <h2 class="sidebar-titulo">AS ÁGUAS, O MAR E O OCEANO  </h2>
                            <p class="descricao">Instalação interativa  com projeção de vídeos com imagens das águas do Rio Grande do Norte.  Celular munido de aplicativo  do projeto é agitado pelo interator, acelerando som , imagem e sequência da play list de vídeos.  A composição musical parte dos sons das águas captados in loco e reelaborados segundo um programa que compõe a trilha sonora a partir desses elementos. A obra trata da imersão e  dos fluxos como campo de navegação e atuação.  </p>
                            <a className="botaops abotaops"  href="https://editor.p5js.org/10Dimensoes/present/9BXRNp1dX">obra interativa</a>
                            <div >
                                
                            </div>
                        </div>
                        <div className="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img   className=" ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>

                    <div className="ffechar todonone">
                       <i> FECHAR </i>
                    </div>
                    <div className="tampavideoTO1">
                    </div>
                    <div className="videoTO1" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="video" playsInline autoPlay muted loop>
                            <source src={agua} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO1"></div>
                    <div className="sobrepo2TO1"></div>
                    <div className="sobrepo3TO1"></div>
                </div>
                <div id="desapa" className="magazineTO1">
                <div className="magazinenova" id="TO1magazinenova">
                    <div id="dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                    </div>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO1  ;